<template>
<el-dialog class="editDialog" title="终止" :visible.sync="visible" :destroy-on-close="true" :close-on-click-modal="false" @close="cancel">
  <template v-if="visible">
    <section>
      <el-form ref="form1" :model="form1" :rules="rule">
        <el-form-item label="终止备注：" prop="remark">
          <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="form1.remark" maxlength="150">
          </el-input>
        </el-form-item>
      </el-form>
    </section>

    <div slot="footer" class="dialog-footer">
      <el-button class="cancelButton" type="primary" @click="cancel">取消</el-button>
      <el-button class="confirmButton" type="primary" @click="submit">保存</el-button>
    </div>
  </template>
</el-dialog>
</template>

<script>
import {
  descriptor,
  obj2urlsp
} from "utils"
export default {
  props: {
    row:{

    },
    pVisible: {
      type: Boolean
    }
  },
  data() {
    return {
      form1: {
        status: -1,
  
      },
      visible: false
    }
  },
  components: {
    searchCompany: () => import("public/searchCompany")
  },
  computed: {
    rule() {
      let that = this;
      return {
        remark: descriptor(new Map([
          [true, "请填写终止备注"]
        ]), "blur")
      }
    }
  },
  methods: {
    resetForm() {
      this.form1 = {
        status: -1,
      };
    },
    submit() {
      this.$refs['form1'].validate(valid => {
        if (valid) {
          this.$axiospost('/operation/risk/update_status',obj2urlsp({
            ...this.form1,
            id:this.row.id,
            userAccount:localStorage.userAccount
          })).then(res => {
            this.$message({
              showClose: true,
              message: '终止成功',
              type: 'success'
            });
            this.$emit('cancel');
          })
        }
      })
    },
    cancel() {
      this.$emit('cancel');
    }
  },
  mounted() {
  },
  watch: {
    pVisible(n) {
      this.visible = n;
      if (n) {
        this.resetForm();
      }
    }
  }
}
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/yinhuan/mine/more/zhongzhi.vue